import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  container: {
    flexGrow: 1,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
  },

  content: {
    flexGrow: 1,
    overflow: 'auto',
    top: '70px',
    position: 'absolute',
    bottom: '76px',
    borderBottom: `1px solid ${theme.palette.divider}`,

    '& > div:not(:first-child)': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    width: '100%',
  },

  footer: {
    display: 'flex',
    padding: theme.spacing(2),
    position: 'absolute',
    bottom: 0,
    width: '100%',
    background: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.divider}`,
    '& > button:first-child': {
      marginLeft: 'auto',
    },
    '& > button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
})
